import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import '../styles/networkToaster.css';

const NetworkToaster = ({ 
  message = '', 
  visible = false, 
  onClose, 
  onClick,
  duration = 5000,
  type = 'warning' 
}) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (visible && message) {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Auto-hide after duration (5 seconds)
      timeoutRef.current = setTimeout(() => {
        onClose();
      }, duration);

      // Cleanup on unmount
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [visible, message, duration, onClose]);

  if (!visible || !message) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '❌';
      case 'success':
        return '✅';
      case 'info':
        return '💡';
      case 'warning':
      default:
        return '⚠️';
    }
  };

  const content = (
    <div 
      className={`network-toaster ${type} ${visible ? 'show' : ''}`}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <div className="toaster-content">
        <span className="toaster-icon">{getIcon()}</span>
        <span className="toaster-message">{message}</span>
      </div>
    </div>
  );

  // Render using a portal so it overlays everything
  return ReactDOM.createPortal(content, document.body);
};

NetworkToaster.propTypes = {
  message: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  duration: PropTypes.number,
  type: PropTypes.oneOf(['warning', 'error', 'success', 'info']),
};

export default NetworkToaster;
